import { useState, useEffect } from 'react';
import {
  getConsumptionByDate,
  getConsumptionData,
  getConsumptionByAPP,
} from '../../../service/consumos/Consumos';
import { SimpleAlert } from '../../../../_mexablock/helpers';
import { ApiResponse, DocData } from '../models/ConsumosModel';

type UseGetConsumptionProps = {
  type: 'msisdn' | 'iccid';
  value: string;
  init_date?: string;
  end_date?: string;
  offer_id?: number;
};

export const useGetAll = (body: any) => {
  const [data, setData] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchPost = async () => {
      setIsLoading(true);
      try {
        const response = await getConsumptionData(body);

        if (response.data?.error) {
          SimpleAlert(
            response.data.message || 'Error desconocido',
            3000,
            'error'
          );
        } else if (response.data?.status === 'success') {
          setData(response.data.doc.data);
        }
      } catch (error: any) {
        const message =
          error?.response?.data?.message ||
          error?.message ||
          'Error en la solicitud';
        SimpleAlert(message, 3000, 'error');
      } finally {
        setIsLoading(false);
      }
    };

    if (body && (body.msisdn || body.iccid)) {
      fetchPost();
    }
  }, [body]);

  return { data, isLoading };
};

export const useGetConsumptionByDate = (params?: UseGetConsumptionProps) => {
  const [data, setData] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchConsumption = async () => {
      setIsLoading(true);
      try {
        const response = await getConsumptionByDate(params!);

        if (response?.status === 'success') {
          setData(response.doc.data);
        } else {
          SimpleAlert(response?.message || 'Error desconocido', 3000, 'error');
        }
      } catch (error: any) {
        const message =
          error?.response?.data?.message ||
          error?.message ||
          'Error en la solicitud';
        SimpleAlert(message, 3000, 'error');
      } finally {
        setIsLoading(false);
      }
    };

    if (params?.type && params?.value) {
      fetchConsumption();
    }
  }, [params]);

  return { data, isLoading };
};

export const useGetConsumptionByAPP = (params?: UseGetConsumptionProps) => {
  const [data, setData] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchConsumption = async () => {
      setIsLoading(true);
      try {
        const response = await getConsumptionByAPP(params!);

        if (response?.status === 'success') {
          setData(response.doc.data);
        } else {
          SimpleAlert(response?.message || 'Error desconocido', 3000, 'error');
        }
      } catch (error: any) {
        const message =
          error?.response?.data?.message ||
          error?.message ||
          'Error en la solicitud';
        SimpleAlert(message, 3000, 'error');
      } finally {
        setIsLoading(false);
      }
    };

    if (params?.type && params?.value) {
      fetchConsumption();
    }
  }, [params]);

  return { data, isLoading };
};
